import { infiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query';
import type { ArticleListItemDto, Paginated } from '@zoxo/shared';

import { api } from '../../lib/api';

/**
 * Paginated PD 수첩 article list (GET /articles, V4 §C). useInfiniteQuery (NOT
 * Suspense) per the frontend exception for infinite scroll. Only isActive=true
 * articles are returned (server-enforced). The cursor is OPAQUE: whatever the
 * API returns in `meta.nextCursor` is passed back as `?cursor=`. An optional
 * `tag` narrows the feed.
 */
export function articlesQuery(tag?: string) {
  return infiniteQueryOptions({
    queryKey: ['articles', tag ?? null],
    queryFn: ({ pageParam }) => {
      const params = new URLSearchParams();
      if (tag) params.set('tag', tag);
      if (pageParam) params.set('cursor', pageParam);
      const qs = params.toString();
      return api.get<Paginated<ArticleListItemDto>>(`/articles${qs ? `?${qs}` : ''}`);
    },
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage.meta.nextCursor ?? undefined,
  });
}

export function useArticles(tag?: string) {
  return useInfiniteQuery(articlesQuery(tag));
}
